export default {
  authBaseUrl: ' https://prodapi.taiservices.info/authservice/api/',
  fetchBaseUrl: ' https://prodapi.taiservices.info/customer/api/',
  fetchSysPriceUrl: 'https://prodapi.taiservices.info/inventory/api/',
  markupBaseUrl: 'https://prodapi.taiservices.info/report/api/',
  calenderBaseUrl: 'https://prodapi.taiservices.info/report/api/',
  fetchFreonBaseUrl: 'https://prodapi.taiservices.info/inventory/api/',
  appVersion: '4.3.3',
  dashboardBaseurl: 'https://prodapi.taiservices.info/report/api/',
  jobBaseUrl: 'https://prodapi.taiservices.info/inventory/api/',
  oilKitsBaseurl: 'https://prodapi.taiservices.info/inventory/api/',
  analystBaseUrl: 'https://prodapi.taiservices.info/management/api/',
  EquipmentReqBaseurl: 'https://prodapi.taiservices.info/inventory/api/',
  // unitBaseUrl: '', // not in use
  ColorMasterUrl: 'https://prodapi.taiservices.info/report/api/',
  // analystBidBaseUrl: 'http://54.175.8.205/api/', // not in use
  listsBaseUrl: 'https://prodapi.taiservices.info/report/api/',
  SiteBaseurl: 'https://prodapi.taiservices.info/inventory/api/',
  InventoryBaseUrl: 'https://prodapi.taiservices.info/admin/api/',
  freonInvoiceBaseUrl: 'https://prodapi.taiservices.info/management/api/',
  oilReportBaseUrl: 'https://prodapi.taiservices.info/customer/api/',
  jobOrderBaseUrl: 'https://prodapi.taiservices.info/management/api/', // not in uat
  ReportTypeUrl: 'https://prodapi.taiservices.info/admin/api/', // not in uat
  AdminBaseUrl: 'https://prodapi.taiservices.info/admin/api/', // not in uat
  PhotosUrl: 'https://prodapi.taiservices.info/admin/api/',
  PhotosEditUrl: 'prodapi.taiservices.info/admin/api/', // not in uat
  JSPaintUrl: 'https://prodapi.taiservices.info/', // not in uat
};

export const showBoardPosition = true;
export const showRoleBased = true;
export const showInspection = true;
export const showExpense = true;
export const vesselOption = true;
